import Infobox from "@digipost/dds-infobox-react";
import { FC, ReactNode } from "react";

import RadioPanel from "../components/radio-panel/RadioPanel";
import Translated from "../infrastructure/Translated";

type OrganisationChoiceProps =
  | {
      organisationNumber: string;
      name: string;
      children?: ReactNode;
      isSelected?: never;
      onChange?: never;
    }
  | {
      organisationNumber: string;
      name: string;
      children?: ReactNode;
      isSelected: boolean;
      onChange: (orgNumber: string) => void;
    };

const OrganisationChoice: FC<OrganisationChoiceProps> = (props) => {
  const body = (
    <>
      <p>
        <Translated
          textKey="select_org.org_number"
          params={{ orgNo: props.organisationNumber }}
        />
      </p>
      {props.children}
    </>
  );

  if (props.onChange) {
    return (
      <RadioPanel
        value={props.organisationNumber}
        label={props.name}
        name={"organisation"}
        checked={props.isSelected}
        onChange={(event) => props.onChange(event.target.value)}
      >
        {body}
      </RadioPanel>
    );
  } else {
    return (
      <Infobox level={2} variant="info" icon={null} title={props.name}>
        {body}
      </Infobox>
    );
  }
};

export default OrganisationChoice;
